// @owners { team: patient-health }
import { type RejectCategoryType } from '@alto/scriptdash/alto/billing/types/v1/reject_category_type';
import { getInsuranceByID } from '~shared/features/insurances/selectors/getInsuranceById';
import { PRICING_SCENARIOS } from '~shared/features/pricing/constants';
import getPrescriptionPricingByID from '~shared/features/pricing/selectors/getPrescriptionPricingByID';
import { getIsFertilityUser } from '~shared/features/users/selectors/getIsFertilityUser';
import { connect } from '~shared/store';
import { type Insurance, type Prescription, type ReduxStateShared } from '~shared/types';
import NotCoveredByInsuranceInfoRow from './NotCoveredByInsuranceInfoRow';

type StateProps = {
  insurance: Insurance | null | undefined;
  isFertility: boolean;
  reject_category: RejectCategoryType | null | undefined;
};

type OwnProps = {
  prescription: Prescription;
};

const mapStateToProps = (state: ReduxStateShared, ownProps: OwnProps): StateProps => {
  const { prescription } = ownProps;
  const { id } = prescription;
  const prescriptionPricing = getPrescriptionPricingByID(state, id);
  const cash_and_categorized_scenario: boolean =
    prescriptionPricing?.scenario === PRICING_SCENARIOS.CASH_AND_CATEGORIZED_REJECT;
  const reject_category = prescriptionPricing?.scenario_data?.cash_and_categorized_reject_data
    ?.reject_category as RejectCategoryType;
  const insurance_id = prescriptionPricing?.scenario_data?.cash_and_categorized_reject_data?.insurance_id;
  const insurance = getInsuranceByID(state, insurance_id || undefined);
  const isFertility =
    cash_and_categorized_scenario &&
    getIsFertilityUser(state, {
      userID: prescription.user_id,
    });

  return {
    insurance: cash_and_categorized_scenario ? insurance : null,
    reject_category: cash_and_categorized_scenario ? reject_category : null,
    isFertility,
  };
};

export default connect(mapStateToProps)(NotCoveredByInsuranceInfoRow);
